import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { API_URL } from "../config";
import HeaderBrandLogo from "./HeaderBrandLogo";
import "./HeaderPublico.css";


export default function HeaderPublico({ cursos = [] }) {
  const navigate = useNavigate();
  const location = useLocation();
  const enCurso = location.pathname.includes("/curso/");
  const [localCursos, setLocalCursos] = useState([]);
  const listaCursos = cursos.length > 0 ? cursos : localCursos;
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [esReducido, setEsReducido] = useState(false);
  const [dropdownAbierto, setDropdownAbierto] = useState(false);
  const dropdownRef = useRef(null);
  const headerRef = useRef(null);

  useEffect(() => {
    const updateHeaderHeight = () => {
      if (headerRef.current) {
        const height = headerRef.current.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    };

    updateHeaderHeight();
    
    const observer = new ResizeObserver(updateHeaderHeight);
    if (headerRef.current) observer.observe(headerRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    if (cursos.length === 0) {
      fetch(`${API_URL}/cursos-publicos`)
        .then((res) => {
          if (!res.ok) throw new Error(`Status: ${res.status}`);
          const contentType = res.headers.get("content-type");
          if (!contentType || !contentType.includes("application/json")) {
            throw new Error("Respuesta no es JSON");
          }
          return res.json();
        })
        .then((data) => setLocalCursos(data))
        .catch((err) => {
          console.error("Error cargando cursos:", err);
          setLocalCursos([]); // Evita estado indefinido
        });
    }
  }, [cursos.length]);

  const toggleMenu = () => {
    setMenuAbierto((prev) => !prev);
    setDropdownAbierto(false);
  };

  const toggleDropdownCursos = () => {
    setDropdownAbierto((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownAbierto(false);
      }
      if (!e.target.closest("header")) {
        setMenuAbierto(false);
        setDropdownAbierto(false);
      }
    };
    const handleScroll = () => setEsReducido(window.scrollY > 50);

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header ref={headerRef} className={`encabezado-publico ${esReducido ? "shrink" : ""}`}>
      <div className="barra-superior">
        <div className="logo-publico">
          <HeaderBrandLogo linkTo="/" className="header-brand-logo ui-integrated-image" />
        </div>
        <button className="hamburguesa" onClick={toggleMenu} aria-label={menuAbierto ? "Cerrar menú" : "Abrir menú"} aria-expanded={menuAbierto} aria-controls="nav-publico-menu">
          {menuAbierto ? "✕" : "☰"}
        </button>
      </div>

      <div className="nav-publico_1">
        <nav id="nav-publico-menu" className={`nav-publico ${menuAbierto ? "abierto" : ""}`}>
          <ul>
            <li>
              <NavLink
                to="/"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  setMenuAbierto(false);
                }}
                className={({ isActive }) => (isActive ? "activo" : "")}
              >
                Inicio
              </NavLink>
            </li>

            <li className="dropdown" ref={dropdownRef}>
              <span onClick={toggleDropdownCursos} className={enCurso ? "activo" : ""}>
                Cursos ▾
              </span>
              {dropdownAbierto && (
                <ul className="dropdown-content">
                  {listaCursos.length === 0 ? (
                    <li className="curso-vacio">Cargando cursos…</li>
                  ) : (
                    listaCursos.map((curso) => {
                      const esCursoActivo = location.pathname === `/curso/${curso._id}`;
                      return (
                        <li
                          key={curso._id}
                          className={esCursoActivo ? "curso-activo" : ""}
                          onClick={() => {
                            navigate(`/curso/${curso._id}`);
                            setMenuAbierto(false);
                            setDropdownAbierto(false);
                          }}
                        >
                          {curso.titulo}
                        </li>
                      );
                    })
                  )}
                </ul>
              )}
            </li>

            <li>
              <NavLink
                to="/login"
                onClick={() => setMenuAbierto(false)}
                className={({ isActive }) => (isActive ? "activo" : "")}
              >
                Acceso al Campus
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/pago"
                onClick={() => setMenuAbierto(false)}
                className={({ isActive }) => (isActive ? "activo" : "")}
              >
                🛒 Carrito
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
